var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.719,
    height: 21,
    viewBox: "0 0 20.719 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71874",
    "data-name": "Path 71874",
    d: "M6,9H19.943l.5-2H8V5H21.724a1,1,0,0,1,.97,1.243l-2.5,10a1,1,0,0,1-.97.757H5a1,1,0,0,1-1-1V4H2V2H5A1,1,0,0,1,6,3ZM6,23a2,2,0,1,1,2-2A2,2,0,0,1,6,23Zm12,0a2,2,0,1,1,2-2A2,2,0,0,1,18,23Z",
    transform: "translate(-2.005 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.382b0a791d917801bc8002d13ec5f476.svg";
export { ForwardRef as ReactComponent };